'use client'

import { faBus, faPlane } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';

export default function MapInfo({ hotelData }: { hotelData: any }) {
    const [activeTab, setActiveTab] = useState('terminals')

    const terminals = hotelData?.terminals
    const interestPoints = hotelData?.interestPoints
    return (
        <div>
            <div className='flex items-center gap-2 '>
                <button onClick={() => setActiveTab('terminals')} className={`${activeTab === 'terminals' ? 'bg-neutral-800 text-white ' : 'text-neutral-800'} 
                   rounded-lg px-2 py-1 text-xs border border-neutral-800`}>
                    Terminals
                </button>
                <button onClick={() => setActiveTab('interest')} className={`${activeTab === 'interest' ? 'bg-neutral-800 text-white ' : 'text-neutral-800'} 
                   rounded-lg px-2 py-1 text-xs border border-neutral-800`}>
                    Interest Points
                </button>
            </div>

            <div className='flex flex-col gap-2 mt-4 w-full'>
                {activeTab === 'terminals' ? terminals?.map((item: any, index: number) =>
                    <div key={item.description.content + index} className='grid gap-2 text-neutral-800 text-sm font-normal grid-cols-[16px,_1fr] items-center'>
                        {item.description.content === 'Airport' ? <FontAwesomeIcon icon={faPlane} /> : <FontAwesomeIcon icon={faBus} />}
                        <div className='flex items-center justify-between'>
                            <div className='flex flex-col gap-0.5'>
                                <span className=''>
                                    {item.name.content}
                                </span>
                                {/* <span>
                                {item.description.content}
                            </span> */}
                            </div>
                            <span className='text-xs'>
                                {item.distance} km
                            </span>
                        </div>
                    </div>) :
                    interestPoints?.map((item: any) =>
                        <div key={item.poiName} className='grid grid-cols-[1fr,_auto] text-sm font-normal'>
                            <span>
                                {item.poiName.replace('.', '')}
                            </span>
                            <span>
                                {item.distance} m
                            </span>
                        </div>)
                }
            </div>

        </div>
    );
}